'use strict';
(function () {
  var _controller = 'userConf.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'profile.resource'];
  function controller($scope, profileResource) {
    /// METHODS
    $scope.save = save;

    /// VARS
    $scope.identificationNumberTypes = (profile
      && profile.enterprise
      && profile.enterprise.identificationNumberTypes
      && profile.enterprise.identificationNumberTypes.length) ? profile.enterprise.identificationNumberTypes : ['DNI', 'CUIT', 'RUT']

    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    /// INIT
    init();

    /////////////////////

    function init() {
      profileResource.get({ _controller: _controller, enterprise: window.enterprise, allFields: true }, function (pf) {
        $scope.user = pf;
        if ($scope.user.birthday) {
          var values = $scope.user.birthday.split('T')[0].split('-')
          $scope.user.bDay = parseInt(values[2]);
          $scope.user.bMonth = values[1];
          $scope.user.bYear = parseInt(values[0]);
        }
      })
    }


    function save() {
      $scope.user._controller = _controller;
      delete $scope.user.enterprise;
      delete $scope.user.missingFields;

      if (!$scope.user.birthday && $scope.user.bYear && $scope.user.bMonth && $scope.user.bDay)
        $scope.user.birthday = $scope.user.bYear + '-' + $scope.user.bMonth + '-' + $scope.user.bDay;
      profileResource.save($scope.user, function () {
        window.profile.missingFields = [];
        if (appNavigator.topPage.data && appNavigator.topPage.data.onClose)
          appNavigator.topPage.data.onClose();
        else
          $scope.$root.resetToLandingPage();
      })
    }


    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    //// FIN CONTROLLER
  }
})();
